import {
  FETCH_PROFILE_DATA_START,
  FETCH_PROFILE_DATA_SUCCESS,
  FETCH_PROFILE_DATA_FAILURE,
  UPDATE_PROFILE_DATA_START,
  UPDATE_PROFILE_DATA_SUCCESS,
  UPDATE_PROFILE_DATA_FAILURE,
  UPDATE_PROFILE_IMAGE_START,
  UPDATE_PROFILE_IMAGE_SUCCESS,
  UPDATE_PROFILE_IMAGE_FAILURE,
  FETCH_USER_ADDRESS_START,
  FETCH_USER_ADDRESS_SUCCESS,
  FETCH_USER_ADDRESS_FAILURE,
  FETCH_EATER_BENEFITS_START,
  FETCH_EATER_BENEFITS_SUCCESS,
  FETCH_EATER_BENEFITS_FAILURE,
  ADD_USER_ADDRESS_FAILURE,
  ADD_USER_ADDRESS_START,
  ADD_USER_ADDRESS_SUCCESS,
  UPDATE_USER_ADDRESS_FAILURE,
  UPDATE_USER_ADDRESS_START,
  UPDATE_USER_ADDRESS_SUCCESS,
  DELETE_USER_ADDRESS_FAILURE,
  DELETE_USER_ADDRESS_START,
  DELETE_USER_ADDRESS_SUCCESS,
  REMOVE_PROFILE_DATA,
  LOGIN_DATA,
  HEAR_ABOUT_US_ERROR,
  HEAR_ABOUT_US_SUCCESS,
  LOGOUT_HANDLER,
  LANDING_PAGE,
  FETCH_OCCASIONS_START,
  FETCH_OCCASIONS_SUCCESS,
  FETCH_OCCASIONS_FAILURE,
  ADD_OCCASION_START,
  ADD_OCCASION_SUCCESS,
  ADD_OCCASION_FAILURE,
  UPDATE_OCCASION_START,
  UPDATE_OCCASION_SUCCESS,
  UPDATE_OCCASION_FAILURE,
  DELETE_OCCASION_START,
  DELETE_OCCASION_SUCCESS,
  DELETE_OCCASION_FAILURE,
  FETCH_CALENDAR_STATUS_START,
  FETCH_CALENDAR_STATUS_SUCCESS,
  FETCH_CALENDAR_STATUS_FAILURE,
  DISCONNECT_CALENDAR_START,
  DISCONNECT_CALENDAR_SUCCESS,
  DISCONNECT_CALENDAR_FAILURE
} from 'actions/account'

const initial = {
  profile: null,
  address: [],
  profileFetching: true,
  profileError: null,
  addressError: null,
  addressFetching: null,
  eaterBenefits: [],
  eaterBenefitsError: null,
  eaterBenefitsFetching: true,
  updateProfileImage: null,
  updateProfileImageError: null,
  updateProfileImageFetching: null,
  updateProfile: null,
  updateProfileError: null,
  loginData: null,
  profileRenderCount: null,
  aboutUs: [],
  landingPageState: false,
  occasions: [],
  occasionsFetching: null,
  occasionsError: null,
  calendarStatus: null,
  calendarFetching: false
}

export default function profile(state = initial, action) {
  switch (action.type) {
    case FETCH_PROFILE_DATA_START:
    case UPDATE_PROFILE_DATA_START:
      return Object.assign({}, state, {
        profileFetching: action.fetching
      })
    case FETCH_PROFILE_DATA_SUCCESS:
      return Object.assign({}, state, {
        profile: action.response,
        profileFetching: action.fetching,
        profileRenderCount: 1
      })
    case FETCH_PROFILE_DATA_FAILURE:
      return Object.assign({}, state, {
        profileError: action.errors,
        profileFetching: action.fetching
      })
    case REMOVE_PROFILE_DATA:
      return Object.assign({}, state, {
        profile: null
      })
    case FETCH_USER_ADDRESS_START:
      return Object.assign({}, state, {
        addressFetching: action.fetching
      })
    case FETCH_USER_ADDRESS_SUCCESS:
      return Object.assign({}, state, {
        address: action.response,
        addressFetching: action.fetching
      })
    case FETCH_USER_ADDRESS_FAILURE:
      return Object.assign({}, state, {
        addressError: action.errors,
        addressFetching: action.fetching
      })
    case FETCH_EATER_BENEFITS_START:
      return Object.assign({}, state, {
        eaterBenefitsFetching: action.fetching
      })
    case FETCH_EATER_BENEFITS_SUCCESS:
      return Object.assign({}, state, {
        eaterBenefits: action.response,
        eaterBenefitsFetching: action.fetching
      })
    case FETCH_EATER_BENEFITS_FAILURE:
      return Object.assign({}, state, {
        eaterBenefitsError: action.errors,
        eaterBenefitsFetching: action.fetching
      })
    case ADD_USER_ADDRESS_START:
      return Object.assign({}, state, {
        addressFetching: action.fetching
      })
    case ADD_USER_ADDRESS_SUCCESS:
      if (action.response.preferred) {
        const newArray = [
          action.response,
          ...state.address.map((item) => ({ ...item, preferred: false }))
        ]
        return Object.assign({}, state, {
          addressFetching: action.fetching,
          address: newArray
        })
      } else {
        return Object.assign({}, state, {
          addressFetching: action.fetching,
          address: [action.response, ...state.address]
        })
      }
    case ADD_USER_ADDRESS_FAILURE:
      return Object.assign({}, state, {
        addressError: action.errors,
        addressFetching: action.fetching
      })
    case UPDATE_USER_ADDRESS_START:
      return Object.assign({}, state, {
        addressFetching: action.fetching
      })
    case UPDATE_USER_ADDRESS_SUCCESS:
      return Object.assign({}, state, {
        // address: updatedAddress,
        addressFetching: action.fetching
      })
    case UPDATE_USER_ADDRESS_FAILURE:
      return Object.assign({}, state, {
        addressError: action.errors,
        addressFetching: action.fetching
      })
    case DELETE_USER_ADDRESS_START:
      return Object.assign({}, state, {
        addressFetching: action.fetching
      })
    case DELETE_USER_ADDRESS_SUCCESS:
      return Object.assign({}, state, {
        addressFetching: action.fetching
      })
    case DELETE_USER_ADDRESS_FAILURE:
      return Object.assign({}, state, {
        addressError: action.errors,
        addressFetching: action.fetching
      })
    case UPDATE_PROFILE_DATA_SUCCESS:
      return Object.assign({}, state, {
        profileFetching: action.fetching,
        updateProfile: action.response
      })
    case UPDATE_PROFILE_DATA_FAILURE:
      return Object.assign({}, state, {
        updateProfileError: action.errors,
        profileFetching: action.fetching
      })
    case UPDATE_PROFILE_IMAGE_START:
      return Object.assign({}, state, {
        updateProfileImageFetching: action.fetching
      })
    case UPDATE_PROFILE_IMAGE_SUCCESS:
      return Object.assign({}, state, {
        updateProfileImageFetching: action.fetching,
        updateProfileImage: action.response
      })
    case UPDATE_PROFILE_IMAGE_FAILURE:
      return Object.assign({}, state, {
        updateProfileImageError: action.errors,
        updateProfileImageFetching: action.fetching
      })
    case LOGIN_DATA:
      return {
        ...state,
        loginData: action.data
      }
    case HEAR_ABOUT_US_SUCCESS:
      return {
        ...state,
        aboutUs: action.data
      }
    case HEAR_ABOUT_US_ERROR:
      return {
        ...state,
        aboutUs: []
      }
    case LOGOUT_HANDLER: {
      return initial
    }
    case LANDING_PAGE: {
      return {
        ...state,
        landingPageState: action.data
      }
    }
    case FETCH_OCCASIONS_START:
      return Object.assign({}, state, { occasionsFetching: action.fetching })
    case FETCH_OCCASIONS_SUCCESS:
      return Object.assign({}, state, {
        occasions: action.response,
        occasionsFetching: action.fetching
      })
    case FETCH_OCCASIONS_FAILURE:
      return Object.assign({}, state, {
        occasionsError: action.errors,
        occasionsFetching: action.fetching
      })
    case ADD_OCCASION_START:
      return Object.assign({}, state, { occasionsFetching: action.fetching })
    case ADD_OCCASION_SUCCESS:
      return Object.assign({}, state, {
        occasionsFetching: action.fetching,
        occasions: [action.response, ...state.occasions]
      })
    case ADD_OCCASION_FAILURE:
      return Object.assign({}, state, {
        occasionsError: action.errors,
        occasionsFetching: action.fetching
      })
    case UPDATE_OCCASION_START:
      return Object.assign({}, state, { occasionsFetching: action.fetching })
    case UPDATE_OCCASION_SUCCESS:
      return Object.assign({}, state, { occasionsFetching: action.fetching })
    case UPDATE_OCCASION_FAILURE:
      return Object.assign({}, state, {
        occasionsError: action.errors,
        occasionsFetching: action.fetching
      })
    case DELETE_OCCASION_START:
      return Object.assign({}, state, { occasionsFetching: action.fetching })
    case DELETE_OCCASION_SUCCESS:
      return Object.assign({}, state, { occasionsFetching: action.fetching })
    case DELETE_OCCASION_FAILURE:
      return Object.assign({}, state, {
        occasionsError: action.errors,
        occasionsFetching: action.fetching
      })
    case FETCH_CALENDAR_STATUS_START:
      return Object.assign({}, state, { calendarFetching: true })
    case FETCH_CALENDAR_STATUS_SUCCESS:
      return Object.assign({}, state, {
        calendarStatus: action.response,
        calendarFetching: false
      })
    case FETCH_CALENDAR_STATUS_FAILURE:
      return Object.assign({}, state, { calendarFetching: false })
    case DISCONNECT_CALENDAR_START:
      return Object.assign({}, state, { calendarFetching: true })
    case DISCONNECT_CALENDAR_SUCCESS:
      return Object.assign({}, state, {
        calendarStatus: { connected: false, email: '', last_synced: null },
        calendarFetching: false
      })
    case DISCONNECT_CALENDAR_FAILURE:
      return Object.assign({}, state, { calendarFetching: false })
    default:
      return state
  }
}
